<template>
  <div>
    <div style="margin-bottom: 10px;">
      <el-row>
        <el-col>
          <erp-button size="mini" @click="submit" v-if="form_1.house_id">保存</erp-button>
          <el-button size="mini" @click="setComponentId('CustomerSaleMain')" >返回</el-button>
        </el-col>
      </el-row>
    </div>
    <el-descriptions size="mini" :column="1" border direction="vertical">
      <el-descriptions-item label="房产转让">
        <div class="col">
          <div class="row">
            <div>
              <el-descriptions size="mini" :column="1" border direction="vertical">
                <el-descriptions-item label="老业主信息">
                  <el-descriptions size="mini" :label-style="{width: '100px'}" :column="1" border>
                    <el-descriptions-item label-class-name="descriptions-label-class" label="业主姓名">
                      <el-input size="mini" v-model="form_1.customer_name" disabled class="w-200"></el-input>
                      <el-button size="mini" icon="el-icon-info" circle title="用户详情" @click="showEditor"></el-button>
                    </el-descriptions-item>
                    <el-descriptions-item label="新地址">
                      <el-input size="mini" v-model="form_1.new_address" class="w-200"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="新联系方式">
                      <el-input size="mini" v-model="form_1.new_contact_info" class="w-200"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="出门证">
                      <el-input size="mini" v-model="form_1.move_house_card" class="w-200"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="搬家时间">
                      <el-date-picker
                        v-model="form_1.move_house_date"
                        type="date"
                        size="mini"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                      </el-date-picker>
                    </el-descriptions-item>
                    <el-descriptions-item label="是否划转预收款">
                      <el-checkbox size="mini" v-model="form_1.is_trans_customer_pre_payment" :true-label="1" :false-label="0" label="是"></el-checkbox>
                    </el-descriptions-item>
                    <el-descriptions-item label="是否划转预收应收款">
                      <el-checkbox size="mini" v-model="form_1.is_trans_pre_should_payment" :true-label="1" :false-label="0" label="是"></el-checkbox>
                    </el-descriptions-item>
                    <el-descriptions-item label="首次签订时间">
                      <el-date-picker
                        v-model="form_1.contract_date"
                        type="date"
                        size="mini"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                      </el-date-picker>
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>
              </el-descriptions>

            </div>
            <div class="ml-10">
              <el-descriptions size="mini" :column="1" border direction="vertical">
                <el-descriptions-item label="新业主信息">
                  <el-descriptions size="mini" :label-style="{width: '100px'}" :column="2" border>
                    <el-descriptions-item label="合同编号">
                      <el-input size="mini" v-model="form_2.contract_id" class="w-200"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="合同名称">
                      <el-input size="mini" v-model="form_2.contract_name" class="w-200"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="签订日期">
                      <el-date-picker
                        v-model="form_2.contract_date"
                        type="date"
                        size="mini"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                      </el-date-picker>
                      <span style="color: #ff3d00;margin-left: 10px;">必填</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="收费对象">
                      <el-checkbox size="mini" v-model="form_2.is_change_house_charge_standard_customer" :true-label="1" :false-label="0" label="更改收费对象"></el-checkbox>
                    </el-descriptions-item>
                    <el-descriptions-item label-class-name="descriptions-label-class" label="业主名称">
                      <el-input size="mini" v-model="form_2.customer_name" class="w-200"></el-input>
                      <el-button size="mini" @click="selectUser">选择客户</el-button>
<!--                      <el-button size="mini" icon="el-icon-user-solid" circle title="新增客户" @click="addCustomer(1)"></el-button>-->
<!--                      <el-button size="mini" icon="el-icon-s-home" circle title="新增企业" @click="addCustomer(2)"></el-button>-->
                    </el-descriptions-item>
                    <el-descriptions-item label="是否主房产">
                      <el-checkbox size="mini" v-model="form_2.is_main_house" :true-label="1" :false-label="0" label="(主房产用于邮寄帐单等)"></el-checkbox>
                    </el-descriptions-item>
                    <el-descriptions-item label="账单结转日期">
                      <el-date-picker
                        v-model="form_2.billing_cut_off_date"
                        type="date"
                        size="mini"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                      </el-date-picker>
                      <span style="color: #ff3d00;margin-left: 10px;">必填</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="附件">
                      <!--            <UploadFileFJ :list="form.appendix||[]" @success="UploadFileFJSuccess" />-->
                      <el-row>
                        <el-col :span="12">
                          <el-link type="primary" @click="$refs.viewFileListRef.UploadFile(data=>{form_2.file_id=data.FileID},form_2.file_id)">上传附件</el-link>
                        </el-col>
                        <el-col :span="12">
                          <el-link type="primary" v-if="form_2.file_id" @click="$refs.viewFileListRef.show(form_2.file_id)">查看下载</el-link>
                        </el-col>
                      </el-row>
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>
              </el-descriptions>

            </div>
          </div>
          <div class="mt-20">
<!--            <div>仪表抄表</div>-->
            <el-descriptions size="mini" :column="1" border direction="vertical">
              <el-descriptions-item label="仪表抄表">
                <div style="width: 100%;">
                  <el-table
                    v-if="pageData" v-loading="loading" :data="pageData.list"
                    border
                    style="width: 100%" height="100">
                    <el-table-column prop="meter_type_name" label="仪表类型" align="center" width="100"></el-table-column>
                    <el-table-column prop="number" label="仪表编号 " align="center" width="100">
                      <template slot-scope="scope">
                        <el-link type="primary">{{scope.row.number}}</el-link>
                      </template>
                    </el-table-column>
                    <el-table-column prop="old_dosage_number" label="去年同期用量" align="center" width="100"></el-table-column>
                    <el-table-column prop="last_read_time" label="上期抄表日期" align="center" width="100"></el-table-column>
                    <el-table-column prop="last_read_number" label="上期读数" align="center" width="100"></el-table-column>
                    <el-table-column prop="read_number" label="本期读数" align="center" width="150">
                      <template slot-scope="scope">
                        <el-input size="mini" placeholder="请输入本期读数" @input="onDosageNumber(scope.row)" v-model="scope.row.read_number" clearable></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="read_time" label="抄表日期" align="center" width="150">
                      <template slot-scope="scope">
                        <el-date-picker
                          style="width: 100%"
                          size="mini"
                          v-model="scope.row.read_time"
                          type="date"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          placeholder="选择日期">
                        </el-date-picker>
                      </template>
                    </el-table-column>
                    <el-table-column prop="admin_name" label="抄表人" align="center" width="150">
                      <template slot-scope="scope">
                        <el-input size="mini" placeholder="请输入抄表人" v-model="scope.row.admin_name" clearable></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="dosage_number" label="本期用量" align="center" width="100"></el-table-column>
                    <el-table-column prop="house_name" label="所在房产" align="center" width="200"></el-table-column>
                  </el-table>
                </div>
              </el-descriptions-item>
            </el-descriptions>

          </div>
        </div>
      </el-descriptions-item>
    </el-descriptions>

    <AddCustomerWindow ref="AddCustomerWindow" />

    <editor v-model="editor.visable" :classValue="editor.classValue" :id="editor.id" :is_edit="false" @callback="editorCallback" />

    <ErpRoomUser ref="ErpRoomUser" />

    <CustomerSaleCarryOver ref="saleOver" />

    <ViewFileList ref="viewFileListRef" />

  </div>
</template>

<script>
import ErpRoomUser from "../../Common/ErpRoomUser";
import AddCustomerWindow from "../../Common/AddCustomerWindow";
import Editor from "../../Customer/editor";
import CustomerSaleCarryOver from "./components/CustomerSaleCarryOver";
import ErpButton from "../../Common/erp-ui/erp-button";
import ViewFileList from "../../Common/ViewFileList";

export default {
  name: "CustomerSaleChange",
  components:{ViewFileList, ErpButton, CustomerSaleCarryOver, ErpRoomUser,AddCustomerWindow,Editor},
  data(){
    return {
      where:{},
      form_1:{
        house_id:"",
        customer_id:"",
        customer_name:"",
        contract_id:"",
        new_address:"",
        new_contact_info:"",
        move_house_card:"",
        move_house_date:"",
        is_trans_customer_pre_payment:false,
        is_trans_pre_should_payment:false,
        contract_date:""
      },
      form_2:{
        house_id:"",
        contract_id:"",
        contract_name:"",
        contract_date:"",
        is_change_house_charge_standard_customer:true,
        customer_id:"",
        customer_name:"",
        is_main_house:true,
        billing_cut_off_date:"",
        file_id:0,
      },
      editor:{
        classValue:1,
        id:0,
        visable:false
      },
      where2: {
        meter_type: "",
        house_name: "",
        number: "",
        charging_standard: "",
        status: "",
        status_ids: [1,0],
        line: "",
        meter_nature: "",
        meter_nature_ids: [1,2,3,4],
        name: "",
        note_status:"",
        note_status_ids:[1,0],
      },
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1
      },
      loading:false,
    }
  },
  inject:['commonObj','setComponentId','componentId','mainObj'],
  watch:{
    "commonObj.house_id":function (n,o) {
      this.where={}
      this.where.house_id=n;
      this.where2.house_id=n;
      this.commonObj.id&&(this.where.id=this.commonObj.id)
      this.componentId==='CustomerSaleChange'&&this.getData();
      this.componentId==='CustomerSaleChange'&&this.getMasterList();
    }
  },
  mounted() {
    this.where.house_id=this.commonObj.house_id;
    this.where2.house_id=this.commonObj.house_id;
    // this.where.house_id&&this.getData();
    // this.where2.house_id&&this.getMasterList();
  },
  activated() {
    this.where.house_id&&this.getData();
    this.where2.house_id&&this.getMasterList();
  },
  methods:{
    getData(){
      const that=this;
      let where=reObject(that.where)
      ERP.getRequest({
        url: "admin/HouseSale/get",
        data: {
          where: JSON.stringify(where),
        }
      }, res => {
        if (res.code) {
          let data=res.data;
          if(!data.house_id){
            data.house_id=data.ph_house_id;
            data.ph_house_id=undefined;
          }else {
            data.ph_house_id=undefined;
          }
          data.is_main_house=!!data.is_main_house;
          data.is_out_store=!!data.is_out_store;
          data.is_trans_customer_pre_payment=!!data.is_trans_customer_pre_payment;
          data.is_trans_pre_should_payment=!!data.is_trans_pre_should_payment;
          that.form_1=res.data
          that.form_2.house_id=data.house_id;
          that.form_2.house_address=data.house_address;
        }
      })
    },
    getMasterList() {
      const that = this;
      that.loading = true;
      let where = reObject(this.where2);
      where.is_update=0;
      ERP.getRequest({
        url: "admin/MeterNote/getMasterList",
        data: {
          where: JSON.stringify(where),
          page: that.pageData.page,
          page_size: that.pageData.pageSize
        }
      }, res => {
        if (res.code) {
          res.data.list.map(ret => {
            return ret;
          })
          that.pageData = res.data
        }
        that.loading = false;
      })
    },
    submit(evt,setLoading){
      const that=this;
      // if(!that.form_1.customer_id){
      //   that.$message.error('选择老用户')
      //   return false;
      // }
      if(!that.form_2.contract_date){
        setLoading(false)
        that.$message.error('选择签订时间')
        return false;
      }
      if(!that.form_2.customer_id){
        setLoading(false)
        that.$message.error('选择新用户')
        return false;
      }
      if(!that.form_2.billing_cut_off_date){
        setLoading(false)
        that.$message.error('选择账单结转日期')
        return false;
      }
      that.$confirm('您正在操作售楼登记，它会为更换该房产的业主，请确认操作！', '提示', {
        confirmButtonText: '下一步',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.submit1((status)=>{
          setLoading(false);
          status&&that.$message.success('请到【发起流程】处，发起流程审批');
          status&&that.setComponentId("CustomerSaleMain");
          // that.$confirm('当前的业主已经更换，下一步将跳转进行账单结转！', '提示', {
          //   confirmButtonText: '下一步',
          //   cancelButtonText: '取消',
          //   type: 'warning'
          // }).then(() => {
          //   that.mainObj.now_customer_id=that.form_1.customer_id;
          //   that.mainObj.new_customer_id=that.form_2.customer_id;
          //
          //   if(that.mainObj.now_customer_id&&that.mainObj.new_customer_id){
          //     that.setComponentId("SaleCarryOver");
          //   }
          // }).catch(() => {
          //   that.$message.error('您当前放弃了账单结转')
          // });


          // that.isOrderStatus(that.commonObj.house_id,count=>{
          //   if(count>0){
          //     that.$refs.saleOver.show({
          //       house_id:that.where.house_id,
          //       house_sale_log_id:id,
          //       callback:function () {
          //         that.setComponentId("CustomerSaleMain");
          //       }
          //     })
          //   }else {
          //     that.setComponentId("CustomerSaleMain");
          //   }
          // });
        })
      }).catch(() => {
        setLoading(false)
        that.$message.error('您当前放弃了改换业主！')
      });

    },
    submit1(callback){
      const that=this;
      let form_1=reObject(that.form_1)
      let form_2=reObject(that.form_2)
      let meter_note_list=reObject(that.getListForm())
      ERP.postRequest({
        url: "admin/HouseSale/saveChangeOver",
        data: {
          project_id:that.mainObj.project_id,
          house_id:that.commonObj.house_id,
          form_1:JSON.stringify(form_1),
          form_2:JSON.stringify(form_2),
          meter_note_str:JSON.stringify(meter_note_list),
          temp_flow:1
        }
      }, res => {
        if (res.code) {
          typeof callback==="function"&&callback(1);
        }else{
          typeof callback==="function"&&callback(0);
          that.$message.error(res.msg||"请求异常")
        }
      })
    },

    addCustomer(type=1){
      const that=this;
      that.$refs.AddCustomerWindow.show(type,data=>{
        that.form_2.customer_id=data.customer_id;
        that.form_2.customer_name=data.name;
      })
    },
    showEditor() {
      const that=this;
      that.getCustomerBase(that.form_1.customer_id,data=>{
        that.editor.classValue = data.class
        that.editor.id = that.form_1.customer_id
        that.editor.visable = true
      })
    },
    getCustomerBase(customer_id,callback){
      ERP.getRequest({
        url: "admin/Customer/getCustomerBase",
        data: {
          id: customer_id,
        }
      }, res => {
        if (res.code) {
          typeof callback ==="function"&&callback(res.data);
        }
      })
    },
    editorCallback(arg) {
      // this.getList()
      if(arg && arg[0]) this.editor.id = arg[0]
    },
    selectUser(){
      const that=this;
      that.$refs.ErpRoomUser.show(data=>{
        if(!data.credentials_code){
          that.$message.error("请选择信息完善的客户,当前缺失证件号码！");
          return;
        }
        that.form_2.customer_id=data.id;
        that.form_2.customer_name=data.name;
      },"")
    },
    onDosageNumber(item){
      item.dosage_number=item.read_number-item.last_read_number;
      item.amount=item.dosage_number*item.charging_standard_money;
    },
    saveListForm(callback){
      const that = this;
      let bool = true;
      this.pageData.list.map(ret=>{
        if(ret.read_number){
          if(ret.read_time == ''){
            bool = false;
          }
        }
      })
      if(bool == false){
        this.$Message.error('抄表日期不能为空');
        return false;
      }

      let form_data=reObject(that.getListForm());
      console.log(form_data);
      ERP.postRequest({url: "admin/MeterNote/saveList", data: {
          form_list:JSON.stringify(form_data)
        }
      }, res => {
        that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
        if (res.code) {
          typeof callback==="function"&&callback()
        }
      })
    },
    getListForm(){
      return this.pageData.list.filter(ret=>{
        return !!(ret.read_number&&ret.read_time);
      }).map(ret=>{
        return {
          meter_id:ret.id,
          read_number:ret.read_number,
          dosage_number:ret.dosage_number,
          last_read_number:ret.last_read_number,
          read_time:ret.read_time,
          last_read_time:ret.last_read_time,
          admin_id:ret.admin_id,
          admin_name:ret.admin_name
        }
      })
    },
    isOrderStatus(house_id,callback){
      ERP.getRequest({url: "admin/HouseSale/isOrderStatus", data: {
          house_id:house_id
        }
      }, res => {
        if (res.code) {
          typeof callback==="function"&&callback(res.data)
        }
      })
    },
    reSaleOrder(){
      const that=this;
      that.$refs.saleOver.show({
        house_id:that.where.house_id,
        house_sale_log_id:id,
        callback:function () {
          that.setComponentId("CustomerSaleMain");
        }
      })
    },
  }
}
function reObject(item) {
  return JSON.parse(JSON.stringify(item));
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/CustomerSaleChange.vue